import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const ChevronIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
  direction = 'right',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''} ${direction || ''}`;

  return (
    <svg
      width={width}
      height={height || width}
      className={classes}
      viewBox="0 0 9 16"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="chevron-icon"
      onClick={onClick}
      fill={fill || '#7E8A96'}
    >
      <path
        fill={fill || '#7E8A96'}
        d="M9.15527e-05 2.34317L1.41431 0.928955L8.48537 8.00002L1.41431 15.0711L9.15527e-05 13.6569L5.65695 8.00002L9.15527e-05 2.34317Z"
      />
    </svg>
  );
};

export default ChevronIcon;
